<template>
  <form @submit.prevent="onSubmit">
    <div class="form-group">
      <label for="first_name"><i class="fas fa-user"></i> Nom</label>
      <input type="text" id="first_name" v-model="formData.firstName" 
             placeholder="Introdueix el teu nom"
             required>
    </div>

    <div class="form-group">
      <label for="last_name"><i class="fas fa-user"></i> Cognoms</label>
      <input type="text" id="last_name" v-model="formData.lastName" 
             placeholder="Introdueix els teus cognoms">
    </div>

    <div class="form-group">
      <label for="phone"><i class="fas fa-phone"></i> Número de telèfon</label>
      <input type="text" id="phone" v-model="formData.phone" 
             placeholder="+34 600 123 456"
             required>
    </div>

    <div class="form-group">
      <label for="email"><i class="fas fa-envelope"></i> Correu electrònic</label>
      <input type="email" id="email" v-model="formData.email" 
             placeholder="el.teu@email.cat"
             required>
    </div>

    <div class="form-group">
      <label for="company"><i class="fas fa-building"></i> Organització</label>
      <input type="text" id="company" v-model="formData.company" 
             placeholder="Nom de la teva organització">
    </div>

    <div class="form-group">
      <label for="job_title"><i class="fas fa-briefcase"></i> Àrea, Unitat o Càrrec</label>
      <input type="text" id="job_title" v-model="formData.jobTitle" 
             placeholder="El teu càrrec, unitat o àrea">
    </div>

    <button type="submit" class="submit-button" :disabled="isGenerating">
      <i :class="isGenerating ? 'fas fa-spinner fa-spin' : 'fas fa-magic'"></i> 
      {{ buttonLabel }}
    </button>

    <div class="buttons-container">
      <button type="button" @click="clearForm" class="clear-button" title="Netejar formulari">
        <i class="fas fa-times"></i>
      </button>
      <a v-if="hasQrImage" :href="qrImage" download="vcard_qr.png" 
         class="download-button" title="Descarregar codi QR">
        <i class="fas fa-download"></i>
      </a>
    </div>
  </form>
</template>

<script>
export default {
  name: 'VCardForm',
  props: {
    qrImage: {
      type: String,
      default: null
    },
    isGenerating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        company: '',
        jobTitle: ''
      }
    }
  },
  computed: {
    buttonLabel() {
      return this.hasQrImage ? 'Regenerar codi QR' : 'Generar codi QR'
    },
    hasQrImage() {
      return this.qrImage !== null
    }
  },
  methods: {
    onSubmit() {
      this.$emit('generate', { ...this.formData })
    },
    clearForm() {
      this.formData = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        company: '',
        jobTitle: ''
      }
      this.$emit('clear')
    }
  },
  mounted() {
    // Añadir efecto de etiqueta flotante
    const inputs = document.querySelectorAll('input[type="text"], input[type="email"]')
    inputs.forEach(input => {
      input.addEventListener('focus', function() {
        this.parentElement.querySelector('label').style.color = '#667eea'
      })
      
      input.addEventListener('blur', function() {
        this.parentElement.querySelector('label').style.color = '#4a5568'
      })
    })
  }
}
</script>

<style scoped>
.form-group {
  position: relative;
  text-align: left;
}

form label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
  transition: color 0.3s ease;
}

form input[type="text"],
form input[type="email"] {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  background: #fff;
  transition: all 0.3s ease;
  outline: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

form input[type="text"]:focus,
form input[type="email"]:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

form input[type="text"]:hover,
form input[type="email"]:hover {
  border-color: #cbd5e0;
}

.submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  margin-top: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.submit-button:active {
  transform: translateY(0);
}

.buttons-container {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.clear-button,
.download-button {
  background: #fff;
  color: #667eea;
  border: 2px solid #667eea;
  padding: 12px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  text-decoration: none;
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.2);
}

.clear-button:hover,
.download-button:hover {
  background: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.clear-button {
  border-color: #e53e3e;
  color: #e53e3e;
}

.clear-button:hover {
  background: #e53e3e;
  color: white;
  box-shadow: 0 6px 20px rgba(229, 62, 62, 0.3);
}

/* Input validation styles */
form input:valid {
  border-color: #48bb78;
}

form input:invalid:not(:placeholder-shown) {
  border-color: #e53e3e;
}

/* Loading state for button */
.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
</style>